<sb-tm-small-footer [ngClass]="{'hide-tm-small-footer' : showTMSmallFooter() }"></sb-tm-small-footer>
